import styled from "styled-components";
import theme from "styles/theme";

const HeaderWrapper = styled.div`
  position: sticky;
  top: 0;
  left: 0;
  padding: 12px 16px;
  text-align: center;
  background-color: ${theme.color.white};
  z-index: 100;

  .like {
    max-width: 24px;
    position: absolute;
    left: 16px;
    cursor: pointer;
  }

  .search {
    max-width: 24px;
    position: absolute;
    right: 12px;
    top: 12px;
    cursor: pointer;
  }
`;

const HeaderTitle = styled.h2`
  font-size: 1.125rem;
  font-weight: bold;
`;

export { HeaderTitle, HeaderWrapper };